import { IkasTransactionInstallmentPrice } from "./installment-price";

export type IkasTransactionPaymentMethodDetail = {
  bankName: string | null;
  binNumber: string;
  cardAssociation: IkasTransactionCardAssociation | null;
  cardFamily: string | null;
  cardType: IkasTransactionCardType | null;
  installment: IkasTransactionInstallmentPrice | null;
  lastFourDigits: string;
  threeDSecure: boolean | null;
};

export enum IkasTransactionCardAssociation {
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  MASTER_CARD = "MASTER_CARD",
  TROY = "TROY",
  VISA = "VISA",
}

export enum IkasTransactionCardType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
  PREPAID = "PREPAID",
}
